<template>
  <div class="order-container">
    <!-- 筛选区域 -->
    <el-card class="filter-card" shadow="never">
      <el-form :inline="true" :model="filterForm" class="filter-form">
        <el-form-item label="订单号">
          <el-input v-model="filterForm.order_dh" placeholder="请输入订单号" clearable />
        </el-form-item>
        <el-form-item label="订单状态">
          <el-select v-model="filterForm.status" placeholder="全部" clearable>
            <el-option label="待付款" value="待付款" />
            <el-option label="待发货" value="待发货" />
            <el-option label="已发货" value="已发货" />
            <el-option label="已完成" value="已完成" />
            <el-option label="已取消" value="已作废" />
            <el-option label="退货中" value="退货中" />
          </el-select>
        </el-form-item>
        <el-form-item label="收货状态">
          <el-select v-model="filterForm.quhuo" placeholder="全部" clearable>
            <el-option label="待收货" value="待收货" />
            <el-option label="已收货" value="已收货" />
          </el-select>
        </el-form-item>
        <el-form-item label="下单时间">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            :clearable="true"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 订单表格 -->
    <el-card class="table-card" shadow="never" style="height:70vh; overflow: auto;">
      <el-table
        :data="orderList"
        v-loading="loading"
        style="width: 100%"
        border
        height="60vh"
        stripe
        row-key="id"
        @row-click="viewOrderDetail"
        class="order-table"
      >
        <!-- 展开列：商品明细 -->
        <el-table-column type="expand" width="50">
          <template slot-scope="props">
            <div class="expand-content">
              <div class="expand-title">
                <span>商品明细</span>
                <span class="expand-count">共 {{ props.row.mx_list?.length || 0 }} 件商品</span>
              </div>
              <el-table
                :data="props.row.mx_list || []"
                size="small"
                border
                stripe
                style="width: 100%"
              >
                <el-table-column type="index" label="序号" width="60" align="center" />
                <el-table-column prop="comlist_v1" label="商品名称" min-width="200" />
                <el-table-column prop="comlist_s1" label="数量" width="100" align="center" />
                <el-table-column prop="comlist_f1" label="单价" width="130" align="right">
                  <template slot-scope="scope">
                    ¥{{ parseFloat(scope.row.comlist_f1).toFixed(2) }}
                  </template>
                </el-table-column>
                <el-table-column label="小计" width="150" align="right">
                  <template slot-scope="scope">
                    ¥{{ (parseFloat(scope.row.comlist_f1) * parseInt(scope.row.comlist_s1)).toFixed(2) }}
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </template>
        </el-table-column>

        <!-- 订单号 -->
        <el-table-column prop="order_dh" label="订单号" min-width="160" sortable>
          <template slot-scope="scope">
            <span class="order-id-text">{{ scope.row.order_dh || scope.row.id }}</span>
          </template>
        </el-table-column>

        <!-- 下单时间 -->
        <el-table-column prop="comlist3" label="下单时间" width="165" sortable>
          <template slot-scope="scope">
            {{ formatTime(scope.row.comlist3) }}
          </template>
        </el-table-column>

        <!-- 店铺 -->
        <el-table-column prop="sh_name" label="店铺" width="120" show-overflow-tooltip />

        <!-- 商品数量 -->
        <el-table-column prop="count_mx" label="商品件数" width="100" align="center" sortable />

        <!-- 商品合计 -->
        <el-table-column label="商品合计" width="120" align="right" sortable prop="jine_all">
          <template slot-scope="scope">
            ¥{{ formatPrice(scope.row.jine_all) }}
          </template>
        </el-table-column>

        <!-- 运费 -->
        <el-table-column label="运费" width="100" align="right">
          <template slot-scope="scope">
            ¥{{ formatPrice(getFreightAmount(scope.row)) }}
          </template>
        </el-table-column>

        <!-- 实付总价 -->
        <el-table-column label="实付总价" width="135" align="right" sortable>
          <template slot-scope="scope">
            <span class="final-price">¥{{ formatPrice(getTotalWithFreight(scope.row)) }}</span>
          </template>
        </el-table-column>

        <!-- 订单状态 -->
        <el-table-column label="订单状态" width="105" align="center">
          <template slot-scope="scope">
            <el-tag :type="getStatusType(scope.row)" size="small" effect="dark">
              {{ getDisplayStatus(scope.row) }}
            </el-tag>
          </template>
        </el-table-column>

        <!-- 收货状态 -->
        <el-table-column label="收货状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.quhuo === '已收货' ? 'success' : scope.row.quhuo === '待收货' ? 'warning' : 'info'"
              size="small"
              effect="plain"
            >
              {{ scope.row.quhuo || '--' }}
            </el-tag>
          </template>
        </el-table-column>

        <!-- 操作 -->
        <el-table-column label="操作" width="320" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="info" plain @click.stop="viewLogistics(scope.row)">
              查看物流
            </el-button>
            <el-button
              v-if="showConfirmButton(scope.row)"
              size="mini"
              type="success"
              @click.stop="confirmOrder(scope.row)"
            >
              确认收货
            </el-button>
            <el-button size="mini" type="primary" plain @click.stop="viewOrderDetail(scope.row)">
              查看详情
            </el-button>
          </template>
        </el-table-column>

        <!-- 空状态 -->
        <template slot="empty">
          <div class="empty-order">
            <i class="el-icon-document" style="font-size: 48px; color: #ddd;"></i>
            <p style="color: #999; margin-top: 8px;">暂无订单信息</p>
          </div>
        </template>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[5, 10, 20, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
      />
    </el-card>

    <!-- 订单详情弹窗 -->
    <el-dialog title="订单详情" :visible.sync="dialogVisible" width="70%" top="5vh">
      <el-descriptions :column="2" border v-if="currentOrder">
        <el-descriptions-item label="订单号">{{ currentOrder.order_dh || currentOrder.id }}</el-descriptions-item>
        <el-descriptions-item label="店铺">{{ currentOrder.sh_name || '店铺' }}</el-descriptions-item>
        <el-descriptions-item label="订单状态">
          <el-tag :type="getStatusType(currentOrder)">
            {{ getDisplayStatus(currentOrder) }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="付款状态">{{ currentOrder.pay_type || '未支付' }}</el-descriptions-item>
        <el-descriptions-item label="收货状态">{{ currentOrder.quhuo || '未收货' }}</el-descriptions-item>
        <el-descriptions-item label="商品合计">¥{{ formatPrice(currentOrder.jine_all) }}</el-descriptions-item>
        <el-descriptions-item label="运费">¥{{ formatPrice(getFreightAmount(currentOrder)) }}</el-descriptions-item>
        <el-descriptions-item label="实付总价">
          <span style="color: #ee530c; font-weight: bold;">¥{{ formatPrice(getTotalWithFreight(currentOrder)) }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="下单时间">{{ currentOrder.comlist3 }}</el-descriptions-item>
        <el-descriptions-item label="收货人">{{ currentOrder.comlist_v2 || '-' }}</el-descriptions-item>
        <el-descriptions-item label="联系电话">{{ currentOrder.comlist_v3 || '-' }}</el-descriptions-item>
        <el-descriptions-item label="收货地址" :span="2">{{ currentOrder.comlist_v4 || '-' }}</el-descriptions-item>
      </el-descriptions>
      <div v-if="currentOrder && currentOrder.mx_list && currentOrder.mx_list.length" style="margin-top: 20px;">
        <h4>商品明细</h4>
        <el-table :data="currentOrder.mx_list" size="small" border stripe>
          <el-table-column type="index" label="序号" width="60" />
          <el-table-column prop="comlist_v1" label="商品名称" />
          <el-table-column prop="comlist_s1" label="数量" width="100" align="center" />
          <el-table-column prop="comlist_f1" label="单价" width="120" align="right">
            <template slot-scope="scope">¥{{ parseFloat(scope.row.comlist_f1).toFixed(2) }}</template>
          </el-table-column>
          <el-table-column label="小计" width="150" align="right">
            <template slot-scope="scope">
              ¥{{ (parseFloat(scope.row.comlist_f1) * parseInt(scope.row.comlist_s1)).toFixed(2) }}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer">
        <el-button @click="dialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>

    <!-- 物流列表弹窗 -->
    <el-dialog
      title="物流列表"
      :visible.sync="logisticsListDialogVisible"
      width="60%"
      :close-on-click-modal="false"
      @close="resetLogisticsList"
    >
      <div v-loading="logisticsListLoading">
        <div v-if="logisticsList.length === 0 && !logisticsListLoading" class="empty-state">
          <i class="el-icon-document"></i>
          <p>暂无物流信息</p>
        </div>
        <div v-else>
          <el-card
            v-for="(item, index) in logisticsList"
            :key="item.id || index"
            class="logistics-item"
            shadow="hover"
            @click.native="viewLogisticsDetail(item)"
          >
            <div class="item-header">
              <div class="header-left">
                <span class="company-name">{{ item.comlist_v2 || '未知快递' }}</span>
                <span class="tracking-number">单号：{{ item.comlist_v1 || '--' }}</span>
              </div>
              <div class="header-right">
                <el-tag :type="getLogisticsStatusType(item.status)" size="small">
                  {{ formatLogisticsStatus(item.status, item.order_status) }}
                </el-tag>
                <i class="el-icon-arrow-right"></i>
              </div>
            </div>

            <div class="item-content">
              <div class="info-row">
                <span class="label">发货时间：</span>
                <span class="value">{{ formatDateTime(item.comlist3) }}</span>
              </div>
              <div class="info-row" v-if="item.comlist_v8">
                <span class="label">收货人：</span>
                <span class="value">{{ item.comlist_v8 }}</span>
              </div>
              <div class="info-row" v-if="item.comlist_v9">
                <span class="label">联系电话：</span>
                <span class="value">{{ item.comlist_v9 }}</span>
              </div>
              <div class="info-row" v-if="item.comlist_v10">
                <span class="label">收货地址：</span>
                <span class="value">{{ item.comlist_v10 }}</span>
              </div>
            </div>

            <div class="item-footer">
              <span v-if="item.update_time" class="update-time">最后更新：{{ formatDateTime(item.update_time) }}</span>
              <el-button type="text" size="small" class="detail-link" @click.stop="viewLogisticsDetail(item)">查看详情</el-button>
            </div>
          </el-card>
          <div class="load-more" v-if="logisticsList.length > 0">
            <span>共 {{ logisticsList.length }} 条物流记录</span>
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- 物流详情弹窗 -->
    <el-dialog
      title="物流详情"
      :visible.sync="logisticsDetailDialogVisible"
      width="55%"
      :close-on-click-modal="false"
      @close="resetLogisticsDetail"
    >
      <div v-loading="logisticsDetailLoading">
        <template v-if="!logisticsDetailError">
          <!-- 头部信息 -->
          <div class="detail-header">
            <div class="company-section">
              <span class="company-name">{{ logisticsDetailCompanyName }}</span>
              <el-tag :type="logisticsDetailStatusType" size="small">
                {{ logisticsDetailData.state || '运输中' }}
              </el-tag>
            </div>
            <div class="waybill-section">
              <span class="label">运单编号：</span>
              <span class="number">{{ logisticsDetailData.nu || '暂无' }}</span>
              <el-button
                v-if="logisticsDetailData.nu"
                type="text"
                size="small"
                icon="el-icon-document-copy"
                @click="copyWaybillNo"
              >复制</el-button>
            </div>
          </div>
          <div v-if="logisticsDetailData.ischeck === '已签收'" class="sign-info">
            <i class="el-icon-check"></i>
            <span>包裹已签收，感谢您的使用</span>
          </div>

          <!-- 轨迹时间轴 -->
          <div class="timeline-section">
            <div class="timeline-header">
              <span class="title">物流轨迹</span>
              <span class="count">共 {{ logisticsDetailTrack.length }} 条记录</span>
            </div>
            <el-timeline v-if="logisticsDetailTrack.length > 0">
              <el-timeline-item
                v-for="(item, index) in logisticsDetailTrack"
                :key="index"
                :timestamp="formatTimelineTime(item.time)"
                placement="top"
                :color="index === 0 ? '#006830' : '#c0c4cc'"
              >
                <div class="timeline-content">
                  <p class="desc">{{ item.context }}</p>
                  <p v-if="item.areaName" class="location">{{ item.areaName }}</p>
                </div>
              </el-timeline-item>
            </el-timeline>
            <div v-else class="empty-timeline">
              <i class="el-icon-document"></i>
              <p>暂无物流轨迹信息</p>
            </div>
          </div>
        </template>
        <div v-else class="error-state">
          <i class="el-icon-warning-outline"></i>
          <p>{{ logisticsDetailErrorMsg }}</p>
          <el-button type="primary" size="small" @click="retryLoadDetail">重新加载</el-button>
        </div>
      </div>
      <span slot="footer">
        <el-button @click="logisticsDetailDialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import xcxrequest from '@/utils/xcxrequest'

export default {
  name: 'OrderListPC',
  data () {
    const now = new Date()
    const end = new Date(now)
    const start = new Date(now)
    start.setMonth(now.getMonth() - 1)
    const format = (d) => {
      const year = d.getFullYear()
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    }
    return {
      loading: false,
      orderList: [],
      filterForm: {
        order_dh: '',
        status: '',
        quhuo: ''
      },
      //   dateRange: [],
      dateRange: [format(start), format(end)],
      currentPage: 1,
      pageSize: 10,
      total: 0,

      // 订单详情
      dialogVisible: false,
      currentOrder: null,

      // 物流列表弹窗
      logisticsListDialogVisible: false,
      logisticsListLoading: false,
      logisticsList: [],

      // 物流详情弹窗
      logisticsDetailDialogVisible: false,
      logisticsDetailLoading: false,
      logisticsDetailError: false,
      logisticsDetailErrorMsg: '',
      logisticsDetailData: {
        nu: '',
        com: '',
        state: '',
        ischeck: '',
        data: []
      },
      logisticsDetailTrack: [],
      currentLogisticsItem: null,

      companyMap: {
        yuantong: '圆通速递',
        zhongtong: '中通快递',
        shentong: '申通快递',
        yunda: '韵达快递',
        shunfeng: '顺丰速运',
        jtexpress: '极兔速递',
        ems: 'EMS',
        debang: '德邦快递',
        youzhengguonei: '中国邮政',
        tiantian: '天天快递',
        zhaijisong: '宅急送',
        baishi: '百世快递',
        jd: '京东物流'
      }
    }
  },
  computed: {
    logisticsDetailCompanyName () {
      if (!this.logisticsDetailData.com) return '未知快递'
      const comLower = this.logisticsDetailData.com.toLowerCase()
      return this.companyMap[comLower] || this.logisticsDetailData.com.toUpperCase()
    },
    logisticsDetailStatusType () {
      const state = this.logisticsDetailData.state || ''
      if (state.includes('签收')) return 'success'
      if (state.includes('派送')) return 'warning'
      if (state.includes('运输')) return 'primary'
      if (state.includes('揽收')) return 'info'
      if (state.includes('异常')) return 'danger'
      return 'info'
    }
  },
  mounted () {
    this.getOrderList()
  },
  methods: {
    // ---------- 订单列表 ----------
    async getOrderList () {
      this.loading = true
      try {
        const params = {
          page: this.currentPage,
          pageSize: this.pageSize,
          crm_id: localStorage.getItem('crm_id'),
          start_date: this.dateRange && this.dateRange.length === 2 ? this.dateRange[0] : '',
          end_date: this.dateRange && this.dateRange.length === 2 ? this.dateRange[1] : '',
          ...this.filterForm
        }
        Object.keys(params).forEach(key => {
          if (params[key] === '' || params[key] === null || params[key] === undefined) {
            delete params[key]
          }
        })
        const res = await xcxrequest.post('/gouwu/get_gouwu_list.php', params)
        if (res.code === 0) {
          this.orderList = res.main_list || []
          this.total = res.total || 0
        } else {
          this.$message.error(res.msg || '获取订单列表失败')
          this.orderList = []
          this.total = 0
        }
      } catch (error) {
        console.error('获取订单列表失败:', error)
        this.$message.error('网络错误，请重试')
      } finally {
        this.loading = false
      }
    },
    handleSearch () {
      this.currentPage = 1
      this.getOrderList()
    },
    handleReset () {
      this.filterForm = { order_dh: '', status: '', quhuo: '' }
      this.dateRange = []
      this.currentPage = 1
      this.getOrderList()
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.currentPage = 1
      this.getOrderList()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getOrderList()
    },

    // ---------- 工具函数 ----------
    formatPrice (price) {
      if (!price && price !== 0) return '0.00'
      const num = parseFloat(price)
      if (isNaN(num)) return '0.00'
      return num.toFixed(2)
    },
    getFreightAmount (order) {
      const freight = order.freight_amount
      if (freight === null || freight === undefined) return 0
      return parseFloat(freight) || 0
    },
    getTotalWithFreight (order) {
      const total = parseFloat(order.jine_all) || 0
      const freight = this.getFreightAmount(order)
      return total + freight
    },
    formatTime (timeStr) {
      if (!timeStr) return ''
      try {
        const date = new Date(timeStr.replace(/-/g, '/'))
        if (!isNaN(date.getTime())) {
          const month = (date.getMonth() + 1).toString().padStart(2, '0')
          const day = date.getDate().toString().padStart(2, '0')
          const hours = date.getHours().toString().padStart(2, '0')
          const minutes = date.getMinutes().toString().padStart(2, '0')
          return `${month}-${day} ${hours}:${minutes}`
        }
        return timeStr
      } catch {
        return timeStr
      }
    },
    formatDateTime (dateStr) {
      return this.formatTime(dateStr)
    },

    // 获取显示状态
    getDisplayStatus (order) {
      if (!order) return ''
      if (order.status_jie === '已作废') return order.status_jie
      if (order.status === '已发货') {
        return order.quhuo === '已收货' ? '已收货' : '待收货'
      }
      return order.status || ''
    },

    getStatusType (order) {
      const status = this.getDisplayStatus(order)
      if (status === '待付款') return 'warning'
      if (status === '待发货') return 'info'
      if (status === '待收货') return 'primary'
      if (status === '已收货' || status === '已完成') return 'success'
      if (status === '已作废') return 'danger'
      if (status === '退货中') return 'danger'
      return 'info'
    },

    // ---------- 确认收货 ----------
    showConfirmButton (order) {
      return order.status_jie !== '已作废' && order.status === '已发货' && order.quhuo !== '已收货'
    },
    async confirmOrder (order) {
      try {
        await this.$confirm('请确认已收到商品，确认后订单将变为已完成状态', '确认收货', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        })
        const res = await xcxrequest.post('/order/order_confirm.php', { order_id: order.id })
        if (res.code === 0) {
          this.$message.success('确认收货成功')
          this.getOrderList()
        } else {
          this.$message.error(res.msg || '确认收货失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('确认收货失败:', error)
          this.$message.error('网络错误，请重试')
        }
      }
    },

    // ---------- 查看详情 ----------
    viewOrderDetail (order) {
      this.currentOrder = order
      this.dialogVisible = true
    },

    // ---------- 物流列表弹窗 ----------
    async viewLogistics (order) {
      if (!order || !order.id) {
        this.$message.warning('订单信息有误')
        return
      }
      this.logisticsListDialogVisible = true
      this.logisticsListLoading = true
      try {
        const res = await xcxrequest.post('/controller/100_logistics.php', {
          a: 'allwuliu',
          order_id: order.id
        })
        if (res.code === '0' && res.res && res.res.length) {
          this.logisticsList = res.res
        } else {
          this.logisticsList = []
          this.$message.info('暂无物流信息')
        }
      } catch (error) {
        console.error('获取物流列表失败:', error)
        this.$message.error('获取物流信息失败')
        this.logisticsList = []
      } finally {
        this.logisticsListLoading = false
      }
    },
    resetLogisticsList () {
      this.logisticsList = []
      this.logisticsListLoading = false
    },

    getLogisticsStatusType (status) {
      if (!status) return 'info'
      if (status === '已签收') return 'success'
      if (status === '运输中') return 'primary'
      if (status === '派送中') return 'warning'
      if (status === '已揽收') return 'info'
      if (status === '问题件') return 'danger'
      return 'info'
    },
    formatLogisticsStatus (status, orderStatus) {
      if (status && status !== 'null' && status !== '') return status
      if (orderStatus && orderStatus !== 'null' && orderStatus !== '') return orderStatus
      return '运输中'
    },

    viewLogisticsDetail (item) {
      if (!item.comlist_v1) {
        this.$message.warning('物流单号缺失')
        return
      }
      this.logisticsListDialogVisible = false
      this.currentLogisticsItem = item
      this.logisticsDetailDialogVisible = true
      this.fetchLogisticsDetail(item.comlist_v1, item.code)
    },

    // ---------- 物流详情弹窗 ----------
    async fetchLogisticsDetail (nu, code) {
      this.logisticsDetailLoading = true
      this.logisticsDetailError = false
      try {
        const res = await xcxrequest.post('/controller/100_logistics.php?a=getWuliuDetail', {
          logistics: nu,
          code: code
        })
        if (res && (res.code === 0 || res.code === '0')) {
          const dataList = res.data || []
          this.logisticsDetailTrack = dataList.map(item => ({
            time: item.time || item.ftime || '',
            context: item.context || '',
            areaName: item.areaName || ''
          }))
          this.logisticsDetailData = {
            nu: res.nu || nu,
            com: res.com || code,
            state: res.state || (this.logisticsDetailTrack[0]?.status === '签收' ? '已签收' : '运输中'),
            ischeck: res.ischeck || '',
            data: dataList
          }
        } else {
          throw new Error(res?.msg || '获取物流详情失败')
        }
      } catch (err) {
        console.error('获取物流详情失败:', err)
        this.logisticsDetailError = true
        this.logisticsDetailErrorMsg = err.message || '网络请求失败，请重试'
      } finally {
        this.logisticsDetailLoading = false
      }
    },
    retryLoadDetail () {
      if (this.currentLogisticsItem) {
        this.fetchLogisticsDetail(this.currentLogisticsItem.comlist_v1, this.currentLogisticsItem.code)
      }
    },
    resetLogisticsDetail () {
      this.logisticsDetailData = { nu: '', com: '', state: '', ischeck: '', data: [] }
      this.logisticsDetailTrack = []
      this.logisticsDetailError = false
      this.logisticsDetailErrorMsg = ''
      this.currentLogisticsItem = null
    },

    copyWaybillNo () {
      const nu = this.logisticsDetailData.nu
      if (!nu) {
        this.$message.warning('暂无运单号')
        return
      }
      navigator.clipboard.writeText(nu).then(() => {
        this.$message.success('运单号已复制')
      }).catch(() => {
        const input = document.createElement('input')
        input.value = nu
        document.body.appendChild(input)
        input.select()
        document.execCommand('copy')
        document.body.removeChild(input)
        this.$message.success('运单号已复制')
      })
    },

    formatTimelineTime (timeStr) {
      if (!timeStr) return ''
      try {
        const date = new Date(timeStr.replace(/-/g, '/'))
        if (isNaN(date.getTime())) return timeStr
        const month = (date.getMonth() + 1).toString().padStart(2, '0')
        const day = date.getDate().toString().padStart(2, '0')
        const hours = date.getHours().toString().padStart(2, '0')
        const minutes = date.getMinutes().toString().padStart(2, '0')
        return `${month}-${day} ${hours}:${minutes}`
      } catch {
        return timeStr
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.order-container {
  padding: 20px;
  background-color: #f0f2f6;
  min-height: 100vh;
  box-sizing: border-box;

  .filter-card {
    // margin-bottom: 20px;
    .filter-form {
      margin-bottom: 0;
    }
  }

  .table-card {
    .order-table {
      :deep(.el-table__expanded-cell) {
        padding: 16px 20px;
        box-sizing: border-box;
        background-color: #fafbfc;
      }

      .expand-content {
        .expand-title {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 12px;
          font-size: 14px;
          font-weight: 600;
          color: #303133;

          .expand-count {
            font-weight: 400;
            color: #909399;
            font-size: 13px;
          }
        }
      }

      .order-id-text {
        font-weight: 500;
        color: #303133;
        font-size: 13px;
      }

      .final-price {
        color: #ee530c;
        font-weight: 700;
        font-size: 15px;
      }

      // 行悬停效果
      :deep(.el-table__row) {
        cursor: pointer;
        transition: background-color 0.15s;

        &:hover {
          background-color: #f5f7fa !important;
        }
      }

      // 操作列按钮组
      .el-button--mini {
        margin: 2px 2px;
      }
    }

    .empty-order {
      text-align: center;
      padding: 40px 0;
      i {
        display: block;
      }
      p {
        margin: 0;
      }
    }

    .pagination {
      margin-top: 20px;
      text-align: right;
    }
  }

  // 物流列表弹窗样式
  .logistics-item {
    margin-bottom: 16px;
    cursor: pointer;
    transition: all 0.2s;
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    }

    .item-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-bottom: 12px;
      border-bottom: 1px solid #ebeef5;
      margin-bottom: 12px;

      .header-left {
        display: flex;
        align-items: baseline;
        gap: 16px;
        .company-name {
          font-size: 16px;
          font-weight: bold;
          color: #303133;
        }
        .tracking-number {
          font-size: 14px;
          color: #909399;
        }
      }
      .header-right {
        display: flex;
        align-items: center;
        gap: 8px;
        .el-icon-arrow-right {
          color: #c0c4cc;
          font-size: 18px;
        }
      }
    }

    .item-content {
      margin-bottom: 12px;
      .info-row {
        display: flex;
        align-items: baseline;
        font-size: 14px;
        margin-bottom: 6px;
        .label {
          color: #909399;
          width: 80px;
          flex-shrink: 0;
        }
        .value {
          color: #606266;
          word-break: break-all;
        }
      }
    }

    .item-footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-top: 12px;
      border-top: 1px solid #ebeef5;
      .update-time {
        font-size: 12px;
        color: #c0c4cc;
      }
      .detail-link {
        font-size: 14px;
        color: #006830;
      }
    }
  }

  .load-more {
    text-align: center;
    padding: 16px 0;
    color: #909399;
    font-size: 14px;
  }

  .empty-state {
    text-align: center;
    padding: 40px 0;
    color: #909399;
    i {
      font-size: 48px;
      color: #ddd;
      display: block;
      margin-bottom: 12px;
    }
    p {
      margin: 0;
    }
  }

  // 物流详情弹窗样式
  .detail-header {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 16px;
    border-bottom: 1px solid #ebeef5;
    margin-bottom: 16px;

    .company-section {
      display: flex;
      align-items: center;
      gap: 12px;
      .company-name {
        font-size: 18px;
        font-weight: bold;
        color: #303133;
      }
    }

    .waybill-section {
      display: flex;
      align-items: center;
      gap: 8px;
      .label {
        color: #909399;
        font-size: 14px;
      }
      .number {
        font-weight: bold;
        color: #303133;
      }
    }
  }

  .sign-info {
    padding: 12px 16px;
    background-color: #f0f9eb;
    border-radius: 4px;
    display: flex;
    align-items: center;
    gap: 8px;
    color: #67c23a;
    margin-bottom: 16px;
    i {
      font-size: 18px;
    }
  }

  .timeline-section {
    .timeline-header {
      display: flex;
      justify-content: space-between;
      align-items: baseline;
      margin-bottom: 16px;
      .title {
        font-size: 16px;
        font-weight: bold;
      }
      .count {
        color: #909399;
        font-size: 14px;
      }
    }

    .timeline-content {
      .desc {
        margin: 0 0 4px 0;
        font-size: 14px;
        color: #606266;
      }
      .location {
        margin: 0;
        font-size: 12px;
        color: #909399;
      }
    }

    .empty-timeline {
      text-align: center;
      padding: 40px 0;
      i {
        font-size: 48px;
        color: #ddd;
        display: block;
        margin-bottom: 12px;
      }
      p {
        color: #909399;
        margin: 0;
      }
    }
  }

  .error-state {
    text-align: center;
    padding: 40px 0;
    i {
      font-size: 48px;
      color: #f56c6c;
      display: block;
      margin-bottom: 16px;
    }
    p {
      color: #909399;
      margin-bottom: 16px;
    }
  }
}
</style>
